import React, { useState, useEffect } from "react";
import { SignalRProvider } from "./contexts/SignalRContext";
import ChatLayout from "./layouts/chat";
import LoginHeader from "./components/Header/loginHeader";
import LoginContent from "./components/loginContent";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token); // Set true if token exists
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <SignalRProvider>
          <ChatLayout />
        </SignalRProvider>
      ) : (
        <>
          <LoginHeader />
          <LoginContent />
        </>
      )}
    </>
  );
}

export default App;
